import { Link } from 'react-router-dom';
import { ArrowLeft, Calendar, Gift, Package } from 'lucide-react';

export default function ArtikelGeschenkboxen() {
  return (
    <main className="pt-20 md:pt-24 bg-[#FDFCF8]">
      <section className="py-16 md:py-24 bg-[#4A5D4F]">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <Link to="/ratgeber" className="inline-flex items-center gap-2 text-white/80 hover:text-white mb-8 transition-colors"><ArrowLeft className="w-4 h-4" />Alle Ratgeber</Link>
          <div className="flex items-center gap-2 text-[#D4C5A9] text-sm mb-4"><Calendar className="w-4 h-4" /><span>Februar 2026</span></div>
          <h1 className="font-serif text-3xl md:text-4xl lg:text-5xl font-medium text-white mb-6 leading-tight">Eid Geschenkboxen: Welche Kombinationen sind beliebt?</h1>
          <p className="text-lg text-white/80 leading-relaxed">Die perfekten Zusammenstellungen für jeden Empfänger – von klassisch bis modern.</p>
        </div>
      </section>
      <article className="py-16 md:py-20">
        <div className="max-w-3xl mx-auto px-6 md:px-12 prose prose-lg max-w-none">
          <p className="text-xl text-[#2C332E] leading-relaxed mb-8">Eine Geschenkbox ist mehr als die Summe ihrer Teile – sie erzählt eine Geschichte. Die richtige Kombination von Produkten zeigt, dass du dir Gedanken gemacht hast. Hier sind die beliebtesten Eid-Geschenkbox-Ideen.</p>

          <div className="space-y-8 mb-12">
            <div className="bg-[#F5F5F0] rounded-2xl p-6">
              <div className="flex items-center gap-3 mb-4">
                <Package className="w-6 h-6 text-[#4A5D4F]" />
                <h3 className="font-serif text-xl font-medium text-[#2C332E]">Die Klassische Eid-Box</h3>
              </div>
              <p className="text-sm text-[#4B5563] mb-4">Zeitlos und immer willkommen – für jeden geeignet.</p>
              <div className="bg-white rounded-lg p-4">
                <ul className="text-sm text-[#4B5563] space-y-2">
                  <li>✓ Premium-Datteln (Medjool oder Ajwa)</li>
                  <li>✓ Baklava-Sortiment</li>
                  <li>✓ Hochwertige Schokolade</li>
                  <li>✓ Orientalischer Tee</li>
                  <li>✓ "Eid Mubarak"-Karte</li>
                </ul>
                <p className="text-sm text-[#4A5D4F] font-medium mt-3">Budget: ca. 30-50 €</p>
              </div>
            </div>

            <div className="bg-[#F5F5F0] rounded-2xl p-6">
              <div className="flex items-center gap-3 mb-4">
                <Package className="w-6 h-6 text-[#4A5D4F]" />
                <h3 className="font-serif text-xl font-medium text-[#2C332E]">Die Wellness-Box (für Frauen)</h3>
              </div>
              <p className="text-sm text-[#4B5563] mb-4">Entspannung nach dem Ramadan – verwöhnen pur.</p>
              <div className="bg-white rounded-lg p-4">
                <ul className="text-sm text-[#4B5563] space-y-2">
                  <li>✓ Parfüm oder Attar-Öl</li>
                  <li>✓ Handcreme mit Arganöl</li>
                  <li>✓ Duftkerze (Oud oder Rose)</li>
                  <li>✓ Gesichtsmaske</li>
                  <li>✓ Badebomben</li>
                </ul>
                <p className="text-sm text-[#4A5D4F] font-medium mt-3">Budget: ca. 40-70 €</p>
              </div>
            </div>

            <div className="bg-[#F5F5F0] rounded-2xl p-6">
              <div className="flex items-center gap-3 mb-4">
                <Package className="w-6 h-6 text-[#4A5D4F]" />
                <h3 className="font-serif text-xl font-medium text-[#2C332E]">Die Spirituelle Box</h3>
              </div>
              <p className="text-sm text-[#4B5563] mb-4">Für den spirituellen Menschen – bedeutungsvoll und wertvoll.</p>
              <div className="bg-white rounded-lg p-4">
                <ul className="text-sm text-[#4B5563] space-y-2">
                  <li>✓ Tasbih (Gebetskette)</li>
                  <li>✓ Dua-Buch</li>
                  <li>✓ Bakhoor/Weihrauch</li>
                  <li>✓ Miswak</li>
                  <li>✓ Datteln</li>
                </ul>
                <p className="text-sm text-[#4A5D4F] font-medium mt-3">Budget: ca. 25-45 €</p>
              </div>
            </div>

            <div className="bg-[#F5F5F0] rounded-2xl p-6">
              <div className="flex items-center gap-3 mb-4">
                <Package className="w-6 h-6 text-[#4A5D4F]" />
                <h3 className="font-serif text-xl font-medium text-[#2C332E]">Die Kinder-Box</h3>
              </div>
              <p className="text-sm text-[#4B5563] mb-4">Freude für die Kleinen – bunt, süß und lehrreich.</p>
              <div className="bg-white rounded-lg p-4">
                <ul className="text-sm text-[#4B5563] space-y-2">
                  <li>✓ Halal-Süßigkeiten</li>
                  <li>✓ Kleines Spielzeug</li>
                  <li>✓ Islamisches Kinderbuch</li>
                  <li>✓ Malbuch mit Stiften</li>
                  <li>✓ Eidi (Geld im Umschlag)</li>
                </ul>
                <p className="text-sm text-[#4A5D4F] font-medium mt-3">Budget: ca. 20-35 €</p>
              </div>
            </div>

            <div className="bg-[#F5F5F0] rounded-2xl p-6">
              <div className="flex items-center gap-3 mb-4">
                <Package className="w-6 h-6 text-[#4A5D4F]" />
                <h3 className="font-serif text-xl font-medium text-[#2C332E]">Die Genießer-Box (für Männer)</h3>
              </div>
              <p className="text-sm text-[#4B5563] mb-4">Für den Mann mit Geschmack – klassisch und maskulin.</p>
              <div className="bg-white rounded-lg p-4">
                <ul className="text-sm text-[#4B5563] space-y-2">
                  <li>✓ Oud-Parfüm oder Attar</li>
                  <li>✓ Premium-Datteln</li>
                  <li>✓ Arabischer Kaffee</li>
                  <li>✓ Tasbih</li>
                  <li>✓ Dunkle Schokolade</li>
                </ul>
                <p className="text-sm text-[#4A5D4F] font-medium mt-3">Budget: ca. 40-60 €</p>
              </div>
            </div>

            <div className="bg-[#F5F5F0] rounded-2xl p-6">
              <div className="flex items-center gap-3 mb-4">
                <Package className="w-6 h-6 text-[#4A5D4F]" />
                <h3 className="font-serif text-xl font-medium text-[#2C332E]">Die Familien-Box</h3>
              </div>
              <p className="text-sm text-[#4B5563] mb-4">Für gemeinsame Momente – zum Teilen und Genießen.</p>
              <div className="bg-white rounded-lg p-4">
                <ul className="text-sm text-[#4B5563] space-y-2">
                  <li>✓ Großes Dattel-Sortiment</li>
                  <li>✓ Orientalisches Tee-Set</li>
                  <li>✓ Baklava-Platte</li>
                  <li>✓ Islamisches Brettspiel</li>
                  <li>✓ Eid-Dekoration</li>
                </ul>
                <p className="text-sm text-[#4A5D4F] font-medium mt-3">Budget: ca. 50-80 €</p>
              </div>
            </div>
          </div>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Tipps für die perfekte Geschenkbox</h2>
            <div className="bg-[#4A5D4F]/10 rounded-xl p-6">
              <ul className="text-[#4B5563] space-y-3">
                <li><strong>1. Die richtige Box wählen:</strong> Holzbox, Karton mit Deckel oder Korb – passend zum Inhalt</li>
                <li><strong>2. Füllmaterial nutzen:</strong> Seidenpapier, Holzwolle oder getrocknete Blüten</li>
                <li><strong>3. Farben abstimmen:</strong> Gold, Grün, Weiß – festlich und elegant</li>
                <li><strong>4. Karte nicht vergessen:</strong> Ein persönlicher Gruß macht den Unterschied</li>
                <li><strong>5. Band oder Schleife:</strong> Der finale Touch für die Präsentation</li>
              </ul>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Fazit</h2>
            <p className="text-[#4B5563] leading-relaxed mb-4">Eine durchdacht zusammengestellte Geschenkbox zeigt mehr Wertschätzung als ein einzelnes teures Geschenk. Die Kombination macht's – und mit diesen Ideen triffst du garantiert ins Schwarze!</p>
            <p className="text-xl text-[#4A5D4F] font-medium">Eid Mubarak! 🌙</p>
          </section>

          <div className="bg-[#F5F5F0] rounded-2xl p-6 mb-8">
            <h3 className="font-serif text-lg font-medium text-[#2C332E] mb-4">Weitere Artikel</h3>
            <ul className="space-y-2">
              <li><Link to="/ratgeber/10-halal-suessigkeiten" className="text-[#4A5D4F] hover:underline">→ Top 10 Halal Süßigkeiten</Link></li>
              <li><Link to="/ratgeber/diy-eid-geschenke" className="text-[#4A5D4F] hover:underline">→ DIY Eid Geschenke</Link></li>
            </ul>
          </div>

          <div className="bg-[#4A5D4F] rounded-2xl p-8 text-center">
            <h3 className="font-serif text-2xl font-medium text-white mb-4">Geschenke entdecken</h3>
            <Link to="/geschenke" className="inline-flex items-center gap-2 bg-white text-[#4A5D4F] px-8 py-3 rounded-full font-medium hover:bg-[#D4C5A9] transition-colors">Jetzt stöbern<Gift className="w-5 h-5" /></Link>
          </div>
        </div>
      </article>
    </main>
  );
}
